import { render } from "./TTMotif.vue?vue&type=template&id=4e10ce39"
import script from "./TTMotif.vue?vue&type=script&lang=js"
export * from "./TTMotif.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__